// GENERATED FILE — do not hand-edit.
//
// Produced by web/scripts/generate-infra.mjs from the Luke/Leia/Cal Ansible
// playbooks and the compose files they deploy (HOME-185). Regenerate with
// `npm run generate:infra` after changing a playbook/compose file, and commit
// the result alongside it — CI checks this file is up to date.
//
// MEMBERSHIP OF THIS SET IS NON-OVERRIDABLE: every container defined in a
// box's playbook/compose is guaranteed to appear here. web/src/config/infra.ts
// may only enrich a box with editorial metadata — it can never add, remove, or
// rename an entry in a box's `services` list. A bare, unadorned entry (no
// label/note) is not a defect: it is the generator telling you a service
// exists that nobody has annotated yet with an `@overview` comment.

import type { ServiceKind } from './infra';

export interface GeneratedService {
    name: string;
    kind: ServiceKind;
    label?: string;
    note?: string;
}

export interface GeneratedBox {
    id: 'luke' | 'leia' | 'cal';
    services: GeneratedService[];
}

export const GENERATED_BOXES: GeneratedBox[] = [
    {
        id: 'luke',
        services: [
            { name: "dd-agent", kind: "container", note: "Datadog agent" },
            { name: "smartctl-exporter", kind: "container" },
            { name: "otel-collector", kind: "container" },
            { name: "volatile-fs", kind: "host", note: "FUSE scratch filesystem (systemd service)" },
            { name: "host-broker", kind: "host", note: "Privileged host-side daemon backing docker-status's /volumes" },
            { name: "taiga-back", kind: "container" },
            { name: "taiga-async", kind: "container" },
            { name: "taiga-front", kind: "container" },
            { name: "taiga-gateway", kind: "container", note: "Taiga edge / routing" },
            { name: "taiga-events", kind: "container" },
            { name: "taiga-db", kind: "container", note: "Taiga Postgres" },
            { name: "taiga-events-rabbitmq", kind: "container" },
            { name: "taiga-async-rabbitmq", kind: "container" },
            { name: "taiga-protected", kind: "container" },
            { name: "scrutiny-collector", kind: "timer", note: "Periodic disk-health scan (systemd timer)" },
            { name: "claude-chats-db", kind: "container", note: "conversation-memory pgvector — database of record (HOME-183)" },
            { name: "docker-status", kind: "container", note: "Read-only status endpoint for this dashboard" },
            { name: "nginx", kind: "container", note: "Back-leg TLS terminator for api.luke (own *.luke cert)" },
            { name: "certbot", kind: "timer", note: "*.luke cert renewal" },
            { name: "samba", kind: "container" },
        ],
    },
    {
        id: 'leia',
        services: [
            { name: "host-broker", kind: "host", note: "Privileged host-side daemon backing docker-status's /volumes" },
            { name: "nginx", kind: "container", note: "Reverse proxy / TLS termination" },
            { name: "certbot", kind: "timer", note: "Wildcard cert renewal" },
            { name: "docker-status", kind: "container", note: "Read-only status endpoint for this dashboard" },
            { name: "nakotp", kind: "container", note: "TOTP service" },
            { name: "dd-agent", kind: "container", note: "Datadog agent" },
            { name: "otel-collector", kind: "container" },
            { name: "scrutiny", kind: "container", note: "Disk-health web UI" },
            { name: "smartctl-exporter", kind: "container" },
            { name: "samba", kind: "container", note: "Time Machine / NAS" },
            { name: "octoprint", kind: "container" },
            { name: "nexus", kind: "container", note: "packages.home.nakomis.com" },
            { name: "opensearch", kind: "container" },
            { name: "guacamole-db", kind: "container" },
            { name: "guacd", kind: "container" },
            { name: "guacamole", kind: "container" },
        ],
    },
    {
        id: 'cal',
        services: [
            { name: "dd-agent", kind: "container", note: "Datadog agent" },
            { name: "host-broker", kind: "host", note: "Privileged host-side daemon backing docker-status's /volumes" },
            { name: "ollama", kind: "container", note: "mxbai-q8 embedding model" },
            { name: "scrutiny-collector", kind: "timer", note: "Periodic disk-health scan (systemd timer)" },
            { name: "docker-status", kind: "container", note: "Read-only status endpoint for this dashboard" },
            { name: "nginx", kind: "container", note: "Back-leg TLS terminator for api.cal (own *.cal cert)" },
            { name: "certbot", kind: "timer", note: "*.cal cert renewal" },
            { name: "embedding-consumer", kind: "container", note: "Async SQS embedding consumer (HOME-183)" },
        ],
    },
];
